<template>
    <div>
        <div class="row">
            <div class="col-2">
                <div class="form-group">
                    <label>Name</label>
                    <input class="form-control form-control-sm" placeholder="Firstname" v-model="form.data.name[0]" v-on:focus="form.focus(`name`, 0)" v-on:blur="form.blur(`name`, 0)">
                </div>
                <div class="form-group">
                    <input class="form-control form-control-sm" placeholder="Lastname" v-model="form.data.name[1]" v-on:focus="form.focus(`name`, 1)" v-on:blur="form.blur(`name`, 1)">
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label>Email</label>
                    <input class="form-control form-control-sm" placeholder="Client email" v-model="form.data.email" v-on:focus="form.focus(`email`)" v-on:blur="form.blur(`email`)">
                </div>
            </div>
            <div class="col-2">
                <div class="form-group">
                    <label>Ref</label>
                    <input class="form-control form-control-sm" placeholder="Client reference" v-model="form.data.ref" v-on:focus="form.focus(`ref`)" v-on:blur="form.blur(`ref`)">
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label>Address</label>
                    <input class="form-control form-control-sm" placeholder="Line 1" v-model="form.data.address[0]" v-on:focus="form.focus(`address`, 0)" v-on:blur="form.blur(`address`, 0)">
                </div>
                <div class="form-group">
                    <input class="form-control form-control-sm" placeholder="Line 2" v-model="form.data.address[1]" v-on:focus="form.focus(`address`, 1)" v-on:blur="form.blur(`address`, 1)">
                </div>
                <div class="form-group">
                    <input class="form-control form-control-sm" placeholder="City" v-model="form.data.address[2]" v-on:focus="form.focus(`address`, 2)" v-on:blur="form.blur(`address`, 2)">
                </div>
                <div class="form-group">
                    <input class="form-control form-control-sm" placeholder="State" v-model="form.data.address[3]" v-on:focus="form.focus(`address`, 3)" v-on:blur="form.blur(`address`, 3)">
                </div>
                <div class="form-group">
                    <input class="form-control form-control-sm" placeholder="Zipcode" v-model="form.data.address[4]" v-on:focus="form.focus(`address`, 4)" v-on:blur="form.blur(`address`, 4)">
                </div>
            </div>
            <div class="col">
                <template v-if="!client.import">
                    <div class="action">
                        <button type="button" class="btn btn-success btn-block btn-sm" v-on:click="form.save()" :disabled="form.pending || !form.edit">
                            <template v-if="form.pending">
                                <i class="fa fa-spinner fa-spin"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-check-circle"></i>
                            </template>
                            <span class="label">Save</span>
                        </button>
                        <template v-if="client._id">
                            <button class="btn btn-sm btn-block btn-dark" v-on:click="form.audit()">
                                <i class="fas fa-history"></i>
                                <span class="label">Audit</span>
                            </button>
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
    div.row {
        margin: 0.5em 0;
    }
    div.row p {
        text-align: right;
    }
    div.action {
        margin-top: 32px;
        width: 6em;
    }
    button {
        text-align: left;
        padding-left: 15px;
        margin-bottom: 17px;
    }
    button i {
        width: 15px;
    }
    span.label {
        padding-left: 10px;
        color: white;
    }
</style>

<script>
    import { Api, Sys } from '../../factory'
    import { alert, events, session } from '../../service'

    export default {
        props: [`client`],
        data() {
            return {
                form: ``
            }
        },
        created() {
            this.init()
        },
        computed: {
        },
        methods: {
            init() {
                var state = session.get(`state`)
                var form = {
                    _edit: ``,
                    _client(c = {}) {
                        var { _id = `` } = c
                        var { data } = this
                        var { email, ref } = data
                        var name = data.name.join(` `)
                        var address = [`line1`, `line2`, `city`, `state`, `zip`]
                            .reduce((o, key, i) => {
                                o[key] = data.address[i]
                                return o
                            }, {})
                        return { _id, address, email, name, ref }
                    },
                    _v(key, index) {
                        var { data } = this
                        return typeof index == `number` ? data[key][index] : data[key]
                    },
                    audit: () => {
                        var { client } = this
                        events.$emit(`firm-menu`, { audit: { client }})
                    },
                    blur(key, index) {
                        var v = this._v(key, index)
                        if (v != this._edit)
                            this.edit++
                    },
                    data: {
                        address: ``,
                        email: ``,
                        name: ``,
                        ref: ``,
                    },
                    edit: 0,
                    focus(key, index) {
                        this._edit = this._v(key, index)
                    },
                    init(c) {
                        var { data } = this
                        data.address = [`line1`, `line2`, `city`, `state`, `zip`].map(key => c.address[key])
                        data.name = c.name.split(` `)
                        data.email = c.email
                        data.ref = c.ref
                        return this
                    },
                    pending: false,
                    save: async () => {
                        var { form } = this
                        var { _id: managerId } = state.user
                        if (form.pending)
                            return
                        form.pending = true
                        var client = form._client(this.client)
                        var data = { managerId, client }
                        try {
                            var resp = await Api.post(`client/save`, data)
                            var { message } = resp.data
                            events.$emit(`firmClients`, { saved: true })
                            alert.message(message, 3e3)
                        } catch(e) {
                            console.log(e.message)
                            alert.error(e.message)
                        } finally {
                            form.pending = false
                        }
                    }
                }
                this.form = form.init(this.client)
            }
        }
    }
</script>